import { useContext } from "react";
import { SnackbarsContext } from "../contexts/snackbars-context";

export const useSnackbars = () => useContext(SnackbarsContext);
